const base = "w-full px-3.5 py-2.5 rounded-xl border border-[#154F49]/30 bg-white text-sm text-[#1A2E2B] placeholder:text-[#5C706B] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#CDA34F] focus-visible:border-[#154F49] aria-[invalid=true]:border-red-700 aria-[invalid=true]:ring-1 aria-[invalid=true]:ring-red-700";
const spanCls = { 2: "sm:col-span-2", 3: "sm:col-span-2 lg:col-span-3" };

const Req = () => <span className="text-[#9B742A]" aria-hidden> *</span>;

const ChoiceGroup = ({ f, invalid }) => (
  <fieldset className={spanCls[f.span] || ""}>
    <legend className="block text-xs font-bold text-[#154F49] mb-2">{f.label}</legend>
    <div className="flex flex-wrap gap-2">
      {f.options.map((o) => {
        const id = `app_${f.name}_${o.replace(/\W+/g, "_")}`;
        return (
          <label key={o} htmlFor={id} className="choice-pill">
            <input id={id} type={f.type} name={f.name} value={o} className="sr-only peer" data-testid={`field-${f.name}-${o.replace(/\W+/g, "-").toLowerCase()}`} aria-invalid={invalid || undefined} />
            <span className="peer-checked:bg-[#154F49] peer-checked:text-[#FBF8F1] peer-checked:border-[#154F49] peer-focus-visible:ring-2 peer-focus-visible:ring-[#CDA34F]">{o}</span>
          </label>
        );
      })}
    </div>
  </fieldset>
);

export const Field = ({ f, error }) => {
  if (f.type === "checkbox" || f.type === "radio") return <ChoiceGroup f={f} invalid={!!error} />;
  const id = `app_${f.name}`;
  const common = {
    id, name: f.name, required: f.required, placeholder: f.placeholder, autoComplete: f.autoComplete,
    "aria-invalid": error ? true : undefined, "aria-describedby": error ? `${id}_err` : undefined,
    "data-testid": `field-${f.name}`, className: base,
  };
  return (
    <div className={spanCls[f.span] || ""}>
      <label htmlFor={id} className="block text-xs font-bold text-[#154F49] mb-1">{f.label}{f.required && <Req />}</label>
      {f.type === "textarea" ? <textarea rows={3} {...common} /> : <input type={f.type || "text"} {...common} />}
      {error && <p id={`${id}_err`} className="text-xs font-semibold text-red-800 mt-1">{error}</p>}
    </div>
  );
};

export const SectionHeader = ({ s }) => (
  <legend className="w-full border-b-2 border-[#154F49] pb-2 mb-5 flex items-end justify-between gap-4">
    <span className="flex items-baseline gap-3">
      <span className="font-serif text-3xl text-[#CDA34F] leading-none">{s.id}</span>
      <span className="text-base sm:text-lg font-bold text-[#154F49] uppercase tracking-wide">{s.title}</span>
    </span>
    <span className="text-xs font-semibold text-[#9B742A] whitespace-nowrap">Section {Number(s.id)} of 10</span>
  </legend>
);
